import { useNavigate } from "react-router";
import { SITE_NAME } from "../../../constants/Settings";

export function ColorfulLogo({
  variant,
  width,
  height = 52, //52
}: {
  variant?: "mobile" | "desktop";
  width?: number;
  height?: number;
}) {
  const navigate = useNavigate();
  return (
    <img
      onClick={() => navigate("/")}
      style={{
        // TODO: Deprecate hardcoded width & height in future release
        ...(height && { height: height }),
        // ...(width && { width: width }),
        cursor: "pointer",
      }}
      src={`/logo-cpa-1.png`}
      alt={`${SITE_NAME} Logo`}
    />
  );
}

export default function Logo({
  variant,
  width,
  height = 52, //52
}: {
  variant?: "mobile" | "desktop";
  width?: number;
  height?: number;
}) {
  const navigate = useNavigate();
  return (
    <img
      onClick={() => navigate("/")}
      style={{
        // TODO: Deprecate hardcoded width & height in future release
        ...(height && { height: height }),
        // ...(width && { width: width }),
        cursor: "pointer",
      }}
      src={`/logo.png`}
      alt={`${SITE_NAME} Logo`}
    />
  );
}

export function SmallLogo({
  variant,
  width,
  height = 80, //52
}: {
  variant?: "mobile" | "desktop";
  width?: number;
  height?: number;
}) {
  const navigate = useNavigate();
  return (
    <img
      onClick={() => navigate("/")}
      style={{
        // TODO: Deprecate hardcoded width & height in future release
        ...(height && { height: height }),
        ...(width && { width: width }),
        cursor: "pointer",
      }}
      src={`/small-logo.png`}
      alt={`${SITE_NAME} Logo`}
    />
  );
}
